<template>
  <footer class="footer" id="footer">
    <div class="container">
      <div class="footer-top">
        <ul class="footer-menu">
          <li>
            <div class="dropup" :class="{open: isIntroOpen}" ref="dropupRef">
              <button class="dropup-toggle" tabindex="0" @click="isIntroOpen = !isIntroOpen">
                회사소개
                <span>
                  <img src="@/assets/img/ico/i-drop-up.svg" alt="열기" />
                </span>
              </button>
              <ul class="dropup-menu">
                <li>
                  <a
                    href="https://www.nicednb.com/cp/company02.do"
                    target="_blank"
                    @click="isIntroOpen = false"
                  >나이스디앤비 소개</a>
                </li>
                <li>
                  <a
                    href="https://www.nicednb.com/cp/company05.do"
                    target="_blank"
                    @click="isIntroOpen = false"
                  >디앤비 소개</a>
                </li>
                <li>
                  <a
                    href="https://www.nicednb.com/cp/company05.do"
                    target="_blank"
                    @click="isIntroOpen = false"
                  >나이스 그룹 소개</a>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a
              href="https://www.nicednb.com/cs/cs-center03-pp.do"
              target="_blank"
              tabindex="0"
            >개인정보처리방침</a>
          </li>
          <li>
            <a
              href="https://www.nicednb.com/cs/cs-center03-ci.do"
              target="_blank"
              tabindex="0"
            >신용정보활용체제공시</a>
          </li>
          <li>
            <a
              href="https://www.nicednb.com/cs/cs-center03-ec.do"
              target="_blank"
              tabindex="0"
            >이메일무단수집거부</a>
          </li>
          <li>
            <router-link to="/apply-partner" tabindex="0">제휴사·회원사 전용 서비스 신청</router-link>
          </li>
        </ul>
        <ul class="footer-sns">
          <li>
            <a
              href="https://www.youtube.com/channel/UCKtjaw6IARfHoplsenQC9hA"
              target="_blank"
              tabindex="0"
            >
              <img src="@/assets/img/ico/i-youtube.svg" alt="유튜브 바로가기" />
            </a>
          </li>
          <li>
            <a href="https://blog.naver.com/nicednbglobal" target="_blank" tabindex="0">
              <img src="@/assets/img/ico/i-bolg.svg" alt="블로그 바로가기" />
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-body">
        <address class="footer-address">
          <ul>
            <li>(주)나이스디앤비</li>
            <li>(04535) 서울특별시 중구 소공로 70, 포스트타워 B동, 15층</li>
            <li>통신판매업신고 : 제2024-서울중구-1736호</li>
          </ul>
          <ul>
            <li>사업자등록번호 : 107-86-24874</li>
            <li>TEL : {{footerTel}}</li>
            <li>FAX : 02-2122-2591</li>
          </ul>
        </address>
        <div class="dropup type2" :class="{open: isSiteOpen}" ref="dropupRef2">
          <button class="dropup-toggle" tabindex="0" @click="isSiteOpen = !isSiteOpen">
            관련사이트
            <span>
              <img src="@/assets/img/ico/i-drop-plus.svg" alt="열기" />
            </span>
          </button>
          <ul class="dropup-menu">
            <li>
              <a href="https://www.nicednb.com" target="_blank" @click="isSiteOpen = false">나이스디앤비</a>
            </li>
            <li>
              <a href="https://gse.nicednb.com" target="_blank" @click="isSiteOpen = false">해외협력사평가</a>
            </li>
            <li>
              <a
                href="https://www.ppscredit.co.kr"
                target="_blank"
                @click="isSiteOpen = false"
              >공공기관 외자평가</a>
            </li>
            <li>
              <a
                href="https://www.nicers.co.kr"
                target="_blank"
                @click="isSiteOpen = false"
              >공공기관 내자평가</a>
            </li>
            <li>
              <a
                href="https://www.nicers.co.kr"
                target="_blank"
                @click="isSiteOpen = false"
              >대기업 제출용 신용평가</a>
            </li>
            <li>
              <a
                href="https://www.creport.co.kr"
                target="_blank"
                @click="isSiteOpen = false"
              >국내기업 정보조회</a>
            </li>
          </ul>
        </div>
      </div>
      <p class="copy">
        © COPYRIGHT 2006 NICE D&amp;B Co.,Ltd.
        <br />ALL RIGHTS RESERVED
      </p>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isIntroOpen: false,
      isSiteOpen: false,
    };
  },
  mounted() {
    window.addEventListener("click", this.handleClickOutside);
    window.addEventListener("click", this.handleClickOutside2);
  },
  beforeUnmount() {
    window.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("click", this.handleClickOutside2);
  },
  computed: {
    ...mapGetters("commonStore", ["footerTel"]),
  },
  methods: {
    handleClickOutside(event) {
      const dropup = this.$refs.dropupRef;
      // 클릭한 장소가 dropup 영역 내부에 없으면 isIntroOpen을 false로
      if (dropup && !dropup.contains(event.target)) {
        this.isIntroOpen = false;
      }
    },
    handleClickOutside2(event) {
      const dropup = this.$refs.dropupRef2;
      // 클릭한 장소가 dropup 영역 내부에 없으면 isIntroOpen을 false로
      if (dropup && !dropup.contains(event.target)) {
        this.isSiteOpen = false;
      }
    },
  },
};
</script>